import React from 'react';
import "../Styles/PercentageBar.css";
import tibetan from "../Assets/tibetan.png";
import theravada from "../Assets/theravada.png";
import mahayana from "../Assets/mahayana.png";

export const PercentageBar = ({percent1, religion1, percent2, religion2}) => {
  var url1,url2=tibetan;
  if(religion1=="Buddhists(Tibetan Buddhism)"){url1 = tibetan;}
  if(religion1=="Buddhists(Theravada)"){url1=theravada;}
  if(religion1=="Buddhists(Mahayana)" || religion1=="East Asian Religiosity"){url1=mahayana;}

  if(religion2=="Buddhists(Tibetan Buddhism)"){url2 = tibetan;}
  if(religion2=="Buddhists(Theravada)"){url2=theravada;}
  if(religion2=="Buddhists(Mahayana)" || religion2=="East Asian Religiosity"){url2=mahayana;}
  
  const firstRStyle = {position:"absolute",width: "30px",left:(percent1-5) + "%",backgroundImage:`url(${url1})`}
  const secondRStyle = {position:"absolute",width: "30px",left:(percent2-5) + "%",backgroundImage:`url(${url2})`, opacity:0.5}

  return (
    <div className="progress-outer">
        <div className='percentbar'>
          <div className='percent' style={{position:"absolute",width: "30px",left:(percent1-5) + "%"}}>{percent1}%</div>
          {religion2&&<div className='percent' style={{position:"absolute",width: "30px",left:(percent2-5) + "%"}}>{percent2}%</div>}
        </div>
        <div className="progress">
        {/* <div className="progress-bar" style={{ width: percent + "%" , backgroundColor: color}}></div> */}
          <div className="firstR" title= {religion1} style={firstRStyle}></div>
          {religion2&&<div className="firstR" title= {religion2} style={secondRStyle}></div>}
        </div>


    </div>
  )
}


export default PercentageBar;